import React from 'lib/react';
import { Switch, Route, Redirect } from 'lib/router';
import Authorize from 'features/authorize';
import Order from 'features/order';
import FinalizeOrder from 'features/finalizeOrder';
import OrderSubmitted from 'features/orderSubmitted';
import OrderHistory from 'features/orderHistory';
import SupportPage from 'features/supportPage';
import Dashboard from 'features/dashboard';
import BillingInformation from 'features/billingInfomation';
import PitchEditor from 'features/pitchEditor/PitchEditor.component';
import ContactInformation from 'features/contactInformation';
import OrderPreferences from 'features/orderPreferences';
import TextAlertSettings from 'features/textAlertSettings';
import UpgradedReport from 'features/finalizeOrder/components/upgradedReport';
import AccountsDeletion from 'features/accountsDeletion/AccountsDeletion.component';
import ReportDetailsPage from 'features/reportDetails';
import Sitemap from 'features/sitemap';
import SitemapApproval from 'features/sitemap/SitemapApproval.component';
import SitemapSubmitted from 'features/sitemap/SitemapSubmitted.component';
import AddressVerification from 'features/addressVerification';
import UploadInformation from 'features/uploadInformation';
import ManagePaymentOptions from 'features/managePaymentOptions/index';
import SubmitPaymentOption from 'features/managePaymentOptions/components/SubmitPaymentOption';
import ReportsChange from 'features/reportTypeChange/ReportsChange.component';
import ServiceAgreement from 'features/serviceAgreement/ServiceAgreement.component';
import AchAuthorization from 'features/achAuthorization/AchAuthorization.component'; // #genai
import AddCardPaymentMethod from 'features/billingInfomation/AddCardPaymentMethod'; // #genai Phase 2
import AddAchPaymentMethod from 'features/billingInfomation/AddAchPaymentMethod'; // #genai Phase 2
import ConsumptionPage from 'features/consumption';
import {
  DASHBOARD_ROUTE, CONTACT_INFORMATION_ROUTE, SUPPORT_ROUTE, ORDER_ROUTE, FINALIZE_ORDER_ROUTE, ORDERS_SUBMITTED_ROUTE, ORDER_HISTORY_ROUTE,
  ORDER_PREFERENCES_ROUTE, BILLING_INFORMATION_ROUTE, AUTHORIZE_ROUTE, REPORT_DETAIL_ROUTE, TEXT_ALERT_SETTINGS_ROUTE, REPORT_CHANGE_ROUTE,
  SITEMPAP_ROUTE, SITEMAP_APPROVAL_ROUTE, SITEMAP_APPROVAL_PATH_ROUTE,
  SITEMAP_SUBMITTED_ROUTE, SITEMAP_SUBMITTED_PATH_ROUTE,
  PITCH_EDITOR_ROUTE, ACCOUNT_DELETION_ROUTE,
  UPGRADE_ROUTE, UPGRADED_REPORT_ROUTE, ADDRESS_VERIFICATION_ROUTE,
  UPLOAD_INFORMATION_ROUTE, MANAGE_PAYMENT_OPTIONS_ROUTE, SERVICE_AGREEMENT_ROUTE,
  ACH_AUTHORIZATION_ROUTE,
  SUBMIT_PAYMENT_OPTION_ROUTE,
  SUBMIT_PAYMENT_OPTION_SUCCESS_ROUTE,
  ANALYTICS_DASHBOARD_ROUTE,
  EXPORT_DATA_ROUTE,
  SERVICE_REQUEST_ROUTE,
  PLACE_ORDER_ROUTE,
  ORDER_BLUEPRINT_ROUTE,
  CONSUMPTION_ROUTE,
  BILLING_INFORMATION_ADD_CARD_ROUTE,
  BILLING_INFORMATION_ADD_ACH_ROUTE,
} from 'constants/RouteConstants';
import { useSelector } from 'lib/redux';
import SubmitPaymentSuccess from 'features/managePaymentOptions/components/SubmitPaymentOption/SubmitPaymentSuccess';
import AnalyticsDashboard from 'features/analyticsDashboard/AnalyticsDashboard.component';
import { isEntitledForAnalyticsSelector, isSubscriptionDashboardV2EnabledSelector } from 'utils/appSelectors.utils'; // #genai
import ServiceRequest from 'features/supportPage/ServiceRequest.component';
import PrivateRoute from './privateRoute';
/**
 * Defines components to routes mapping.
 *
 * Every time a new view is created, entry is required here to map the component to a specific route.
 *
 * [IMPORTANT]
 * All route entries are required to be done before the notFound component.
 * @returns {XML}
 */
const routes = () => {
  const isEntitledForAnalytics = useSelector(isEntitledForAnalyticsSelector);
  const isSubscriptionDashboardV2Enabled = useSelector(isSubscriptionDashboardV2EnabledSelector); // #genai
  return (
    <Switch>
      <Route path={AUTHORIZE_ROUTE} component={Authorize} />
      <Route exact path={PLACE_ORDER_ROUTE} component={Order} />
      <PrivateRoute exact path={ORDER_ROUTE} component={Order} />
      <PrivateRoute exact path={ORDER_BLUEPRINT_ROUTE} component={Order} />
      <PrivateRoute exact path={FINALIZE_ORDER_ROUTE} component={FinalizeOrder} />
      <PrivateRoute exact path={ORDERS_SUBMITTED_ROUTE} component={OrderSubmitted} />
      <PrivateRoute exact path={ORDER_HISTORY_ROUTE} component={OrderHistory} />
      <PrivateRoute exact path={SUPPORT_ROUTE} component={SupportPage} />
      <PrivateRoute exact path={SERVICE_REQUEST_ROUTE} component={ServiceRequest} />
      <PrivateRoute exact path={DASHBOARD_ROUTE} component={Dashboard} />
      <PrivateRoute exact path={CONTACT_INFORMATION_ROUTE} component={ContactInformation} />
      <PrivateRoute path={ORDER_PREFERENCES_ROUTE} component={OrderPreferences} />
      <PrivateRoute exact path={BILLING_INFORMATION_ROUTE} component={BillingInformation} />
      <PrivateRoute exact path={TEXT_ALERT_SETTINGS_ROUTE} component={TextAlertSettings} />
      <PrivateRoute exact path={MANAGE_PAYMENT_OPTIONS_ROUTE} component={ManagePaymentOptions} />
      <PrivateRoute exact path={REPORT_DETAIL_ROUTE} component={ReportDetailsPage} />
      <Route exact path={SITEMPAP_ROUTE} component={Sitemap} />
      <Route exact path={SITEMAP_APPROVAL_PATH_ROUTE} component={SitemapApproval} />
      <Route exact path={SITEMAP_APPROVAL_ROUTE} component={SitemapApproval} />
      <Route exact path={SITEMAP_SUBMITTED_PATH_ROUTE} component={SitemapSubmitted} />
      <Route exact path={SITEMAP_SUBMITTED_ROUTE} component={SitemapSubmitted} />
      <PrivateRoute exact path={UPGRADE_ROUTE} component={FinalizeOrder} />
      <PrivateRoute exact path={UPGRADED_REPORT_ROUTE} component={UpgradedReport} />
      <Route path={PITCH_EDITOR_ROUTE} component={PitchEditor} />
      <Route path={REPORT_CHANGE_ROUTE} component={ReportsChange} />
      <Route exact path={ADDRESS_VERIFICATION_ROUTE} component={AddressVerification} />
      <PrivateRoute exact path={ACCOUNT_DELETION_ROUTE} component={AccountsDeletion} />
      <PrivateRoute exact path={SERVICE_AGREEMENT_ROUTE} component={ServiceAgreement} />
      {/* #genai */}
      <PrivateRoute exact path={ACH_AUTHORIZATION_ROUTE} component={AchAuthorization} />
      {/* #genai Phase 2: the picker renders INLINE within BillingInformation; the card/ACH add
          screens are dedicated routes (each guards on the ENABLE_MULTI_PAYMENT_METHODS flag). */}
      <PrivateRoute exact path={BILLING_INFORMATION_ADD_CARD_ROUTE} component={AddCardPaymentMethod} />
      <PrivateRoute exact path={BILLING_INFORMATION_ADD_ACH_ROUTE} component={AddAchPaymentMethod} />
      <Route exact path={UPLOAD_INFORMATION_ROUTE} component={UploadInformation} />
      {isEntitledForAnalytics && <PrivateRoute path={EXPORT_DATA_ROUTE} component={AnalyticsDashboard} />}
      {isEntitledForAnalytics && <PrivateRoute path={ANALYTICS_DASHBOARD_ROUTE} component={AnalyticsDashboard} />}
      <PrivateRoute exact path={SUBMIT_PAYMENT_OPTION_ROUTE} component={SubmitPaymentOption} />
      <PrivateRoute exact path={SUBMIT_PAYMENT_OPTION_SUCCESS_ROUTE} component={SubmitPaymentSuccess} />
      {isSubscriptionDashboardV2Enabled && <PrivateRoute exact path={CONSUMPTION_ROUTE} component={ConsumptionPage} />}
      {' '}
      {/* #genai */}
      <Route path="/" component={() => <Redirect to={DASHBOARD_ROUTE} />} />
    </Switch>
  );
};

export default routes;
